export const APP_NAME = 'Vylor - Químicos de Campo'

export const createPageTitle = (message) => `${APP_NAME}: ${message}`
